export function shallowEqualIgnoreOrder(obj1, obj2) {
    if (obj1 === obj2) return true;
    if (
        typeof obj1 !== 'object' ||
        typeof obj2 !== 'object' ||
        obj1 === null ||
        obj2 === null
    ) {
        return false;
    }
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) return false;
    for (let key of keys1) {
        if (!Object.prototype.hasOwnProperty.call(obj2, key)) {
            return false;
        }
        if (obj1[key] !== obj2[key]) {
            return false;
        }
    }
    return true;
}

export function getFontSize(val, isMobile) {
    if(val) {
        if(isMobile) {
            return val/1.1
        }
        else {
            return val
        }
    }
    else if(!val) {
        return isMobile ? 14 : 16
    }
    else {
        return val;
    }
}

export function getResponsivePaddingValues(padding, isMobile) {
    if (!padding) {
        return undefined;
    }

    return {
        top: isMobile ? (padding.mobileTop ?? padding.top ?? 0) : (padding.top ?? 0),
        bottom: isMobile ? (padding.mobileBottom ?? padding.bottom ?? 0) : (padding.bottom ?? 0),
        right: isMobile ? (padding.mobileRight ?? padding.right ?? 0) : (padding.right ?? 0),
        left: isMobile ? (padding.mobileLeft ?? padding.left ?? 0) : (padding.left ?? 0),
    };
}

export function getResponsiveValue(value, mobileValue, isMobile) {
    return isMobile ? (mobileValue ?? value) : value;
}

export function getResponsivePadding(padding, isMobile) {
    const values = getResponsivePaddingValues(padding, isMobile);
    return values ? `${values.top}px ${values.right}px ${values.bottom}px ${values.left}px` : undefined;
}

export function getMerchantCode(cmCode, serviceCode) {
    return process.env.REACT_APP_APIGATEWAY_URL ? null : 
        (cmCode === 'uat_test' ? '' : `api/merchant/${cmCode}/${serviceCode}/`);
}

export function getMerchantCode2(cmCode) {
    return cmCode === 'uat_test' ? '' : cmCode;
}